import { Mapper } from "../../../../base/utils/mapper";
import { DataInitialResponseModel } from "../../../../domain/models/consult/data-initial-response.model";
import { DataInitialResponseEntity } from "../entities/data-initial-response.entity";


export class DataInitialImplementationRepositoryMapper extends Mapper<DataInitialResponseEntity, DataInitialResponseModel> {
    mapFrom(param: DataInitialResponseEntity): DataInitialResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: DataInitialResponseModel): DataInitialResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}